let env = process.env
const config = {
  BASE_URL: env.REACT_APP_BASE_URL,
  // PER_PAGE: parseInt(env.REACT_APP_PER_PAGE) || 10
  PER_PAGE: 10,
  B2B_SECRET_KEY: env.REACT_APP_B2B_SECRET_KEY,
  ACTUALCPM: +env.REACT_APP_ACTUALCPM,
  ACTUALCPC: +env.REACT_APP_ACTUALCPC,
  CSTUsers: env.REACT_APP_CSTUsers,
  AWS_BRAND_URL: env.REACT_APP_AWS_BRAND_URL,
  CARDLIST_TEAMS: env.REACT_APP_CARDLIST_TEAMS,
  CUSTOM_ADVS: env.REACT_APP_CUSTOM_ADVS,
  HEADLINE: env.REACT_APP_HEADLINE,
  DESCRIPTION: env.REACT_APP_DESCRIPTION,
  VAPID_publicKey:env.REACT_APP_VAPID_PUBLIC_KEY,
  APP_URL_PREFIX:env.REACT_APP_URL_PREFIX,
  DEVS : env.REACT_APP_DEVS || [],
  MAIN_CROP_RATIO : env.REACT_APP_MAIN_CROP_RATIO,
  OTHER_CROP_RATIO : env.REACT_APP_OTHER_CROP_RATIO,
  SALES_EMAILS_B2B_REPORTS:env.REACT_APP_SALES_EMAILS_B2B_REPORTS || []
}
export default config